import type { JobLocationType, RoleDraft } from './types';

export const hasOfficeWork = (
  locationTypes: readonly JobLocationType[],
): boolean =>
  locationTypes.includes('Onsite') || locationTypes.includes('Hybrid');

export const targetCityForRequest = (
  targetCity: string,
  locationTypes: readonly JobLocationType[],
): string | null =>
  hasOfficeWork(locationTypes) ? targetCity.trim() || null : null;

/** Only a remote-only job may be open to anywhere: an onsite or hybrid job hires in the countries of its office. */
export const isRemoteOnly = (
  locationTypes: readonly JobLocationType[],
): boolean =>
  locationTypes.length > 0 && locationTypes.every((type) => type === 'Remote');

/** Where the search looks, as the API takes it: Anywhere, with no countries, only for a remote-only job. */
export const countriesForRequest = (
  countries: readonly string[],
  isAnywhere: boolean,
  locationTypes: readonly JobLocationType[],
): { countries: string[]; isAnywhere: boolean } => {
  const anywhere = isAnywhere && isRemoteOnly(locationTypes);
  return { countries: anywhere ? [] : [...countries], isAnywhere: anywhere };
};

/** A job's search can start only with somewhere to look: a country, or anywhere for a remote-only job. */
export const hasSomewhereToSearch = ({
  countries,
  isAnywhere,
  locationTypes,
}: Pick<RoleDraft, 'countries' | 'isAnywhere' | 'locationTypes'>): boolean =>
  countries.length > 0 || (isAnywhere && isRemoteOnly(locationTypes));
